import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import '../shared.css';

const BranchCreate = () => {
  const history = useHistory();
  const { isAuthenticated, companyId, userId, logout, token } = useAuth();

  const [name,           setName]           = useState('');
  const [branchCode,     setBranchCode]     = useState('');
  const [contactNumber1, setContactNumber1] = useState('');
  const [email,          setEmail]          = useState('');
  const [gstNumber,      setGstNumber]      = useState('');
  const [cinNumber,      setCINNumber]      = useState('');
  const [addressLine,    setAddressLine]    = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage,   setErrorMessage]   = useState('');

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
  }, [isAuthenticated, companyId, userId, token, logout]);

  const clearForm = () => {
    setName(''); setBranchCode(''); setContactNumber1('');
    setEmail(''); setGstNumber(''); setCINNumber(''); setAddressLine('');
  };

  const submitData = async (e) => {
    e.preventDefault();
    if (!name || !contactNumber1 || !branchCode) {
      setErrorMessage('Branch Name, Code and Contact Number are required.');
      return;
    }
    try {
      await postData('BranchApi', {
        Name: name, BranchCode: branchCode, ContactNumber1: contactNumber1,
        Email: email, GSTNumber: gstNumber, CINNumber: cinNumber,
        Addressline: addressLine, CompanyId: companyId,
        CreatedBy: userId, CreatedDate: new Date(),
      }, token);
      setSuccessMessage('Branch created successfully!');
      setErrorMessage('');
      clearForm();
      history.push('/branchIndex');
    } catch (err) {
      console.error('Branch Create error:', err);
      setErrorMessage('Failed to create branch. Please try again.');
    }
  };

  return (
    <Fragment>
      <div className="pg-container">
        <form onSubmit={submitData}>

          {/* Header */}
          <div className="pg-header">
            <h5 className="pg-title">Branch — Create</h5>
            <div className="pg-header-actions">
              <button type="submit" className="pg-btn pg-btn-success">
                <DoneIcon /> Save
              </button>
              <Link to="/branchIndex" className="pg-btn pg-btn-neutral">
                <ReplyAllIcon /> Back to List
              </Link>
            </div>
          </div>

          {/* Alerts */}
          {errorMessage   && <div className="pg-alert pg-alert-error">{errorMessage}</div>}
          {successMessage && <div className="pg-alert pg-alert-success">{successMessage}</div>}

          {/* Row 1 — Name + Code */}
          <div className="pg-card">
            <div className="pg-form-grid pg-form-grid-2">
              <div className="pg-field">
                <label className="pg-label">Branch Name <span className="req">*</span></label>
                <input className="pg-input" type="text" placeholder="Enter branch name"
                  value={name} onChange={e => setName(e.target.value)}
                  required maxLength={50} />
              </div>
              <div className="pg-field">
                <label className="pg-label">Branch Code <span className="req">*</span></label>
                <input className="pg-input" type="text" placeholder="Enter branch code"
                  value={branchCode} onChange={e => setBranchCode(e.target.value)}
                  maxLength={20} />
              </div>
            </div>

            {/* Row 2 — Contact / Email / GST / CIN */}
            <div className="pg-form-grid pg-form-grid-4">
              <div className="pg-field">
                <label className="pg-label">Contact Number <span className="req">*</span></label>
                <input className="pg-input" type="text" placeholder="Enter contact number"
                  value={contactNumber1} onChange={e => setContactNumber1(e.target.value)}
                  required maxLength={15} />
              </div>
              <div className="pg-field">
                <label className="pg-label">Email</label>
                <input className="pg-input" type="email" placeholder="Enter email"
                  value={email} onChange={e => setEmail(e.target.value)}
                  maxLength={40} />
              </div>
              <div className="pg-field">
                <label className="pg-label">GST Number</label>
                <input className="pg-input" type="text" placeholder="Enter GST number"
                  value={gstNumber} onChange={e => setGstNumber(e.target.value)}
                  maxLength={15} />
              </div>
              <div className="pg-field">
                <label className="pg-label">CIN Number</label>
                <input className="pg-input" type="text" placeholder="Enter CIN number"
                  value={cinNumber} onChange={e => setCINNumber(e.target.value)}
                  maxLength={30} />
              </div>
            </div>

            {/* Row 3 — Address */}
            <div className="pg-form-grid pg-form-grid-1">
              <div className="pg-field">
                <label className="pg-label">Address Line</label>
                <input className="pg-input" type="text" placeholder="Enter address"
                  value={addressLine} onChange={e => setAddressLine(e.target.value)}
                  maxLength={200} />
              </div>
            </div>
          </div>

        </form>

        <div className="pg-watermark">
          <CopyrightIcon style={{ fontSize: 12 }} />
          <b>EFFTABS SOLUTIONS LLP</b>
        </div>
      </div>
    </Fragment>
  );
};

export default BranchCreate;
